// extracted by extract-css-chunks-webpack-plugin
module.exports = {"promote_box":"promote_box-2INMknj_"};